
const modules = {};


const files = require.context(
  '@/view',
  true,
  /\.vue$/
);

files.keys().forEach(key => {

  const name = key
    .replace('./', '')
    .replace('.vue', '');

  modules[name] = files(key).default;

});

export default modules;

console.log("所有页面", modules);



// WEBPACK FOOTER //
// ./src/router/dynamicRouter.js